import { useFormApi } from 'informed';
import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useReducer, useEffect } from 'react';
import ReactTable from 'react-table';
import findIndex from 'lodash/findIndex';
import { setSelected, setFiltered, clearFiltered } from './TableActions.js';
import TableContext from './TableContext.js';
import TableReducer from './TableReducer.js';

function TableController(_ref) {
  var children = _ref.children,
    data = _ref.data,
    defaultSorted = _ref.defaultSorted,
    isSelectable = _ref.isSelectable,
    rowIdentifier = _ref.rowIdentifier,
    columns = _ref.columns,
    _ref$paginated = _ref.paginated,
    paginated = _ref$paginated === void 0 ? false : _ref$paginated,
    _ref$defaultPageSize = _ref.defaultPageSize,
    defaultPageSize = _ref$defaultPageSize === void 0 ? 10 : _ref$defaultPageSize,
    _ref$sortable = _ref.sortable,
    sortable = _ref$sortable === void 0 ? true : _ref$sortable,
    selectedRef = _ref.selectedRef,
    _ref$onSelectedChange = _ref.onSelectedChange,
    onSelectedChange = _ref$onSelectedChange === void 0 ? function (selected) {} : _ref$onSelectedChange,
    _ref$tableApi = _ref.tableApi,
    tableApi = _ref$tableApi === void 0 ? function () {} : _ref$tableApi,
    _ref$returnAll = _ref.returnAll,
    returnAll = _ref$returnAll === void 0 ? false : _ref$returnAll;
  // ---- INITIALIZATION ---- //
  var _useFormApi = useFormApi(),
    reset = _useFormApi.reset;
  var INITIAL_STATE = {
    filtered: [],
    isAllSelected: data.every(function (item) {
      return !!item.selected;
    }),
    selected: data.filter(function (item) {
      return item.selected;
    })
  };
  var _useReducer = useReducer(TableReducer(data, rowIdentifier), INITIAL_STATE, function () {
      return INITIAL_STATE;
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    tableState = _useReducer2[0],
    dispatch = _useReducer2[1];
  // ---- FILTERING ---- //
  var handleDefaultFilter = function handleDefaultFilter(filter, row) {
    var id = filter.id,
      value = filter.value;
    var filterValue;
    if (typeof value === 'number') {
      filterValue = value;
    } else {
      filterValue = value.toLowerCase();
    }
    var rowValue = row[id].toLowerCase();
    return rowValue.indexOf(filterValue) !== -1;
  };
  var onFilteredChange = function onFilteredChange(filtered) {
    dispatch(setFiltered(filtered));
  };
  var clearFilters = function clearFilters(e) {
    e.preventDefault();
    dispatch(clearFiltered());
    reset();
  };
  // ------------------- //
  // ---- SELECTING ---- //
  var isRowSelected = function isRowSelected(r) {
    return tableState.selected.some(function (row) {
      return row[rowIdentifier] === r[rowIdentifier];
    });
  };
  useEffect(function () {
    var returnedData = tableState.selected;
    if (returnAll) {
      returnedData = data.map(function (item) {
        var index = findIndex(tableState.selected, function (o) {
          return o[rowIdentifier] === item[rowIdentifier];
        });
        var selected = index !== -1;
        return _objectSpread2(_objectSpread2({}, item), {}, {
          selected: selected
        });
      });
    }
    if (selectedRef && selectedRef.current) {
      selectedRef.current = returnedData;
    }
    onSelectedChange(returnedData);
  }, [tableState.selected]);
  // ------------------- //
  useEffect(function () {
    tableApi({
      setSelectedData: function setSelectedData(input) {
        dispatch(setSelected(input));
      }
    });
  }, []);
  var context = {
    clearFilters: clearFilters,
    dispatch: dispatch,
    filtered: tableState.filtered,
    isAllSelected: tableState.isAllSelected,
    isRowSelected: isRowSelected,
    isSelectable: isSelectable,
    rowIdentifier: rowIdentifier,
    selected: tableState.selected
  };
  return /*#__PURE__*/React.createElement(TableContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(ReactTable, {
    columns: columns,
    data: data,
    sortable: sortable,
    filtered: tableState.filtered,
    onFilteredChange: onFilteredChange,
    defaultFilterMethod: handleDefaultFilter,
    defaultPageSize: paginated ? defaultPageSize : undefined,
    defaultSorted: defaultSorted
  }, children));
}

export default TableController;
